import axios from 'axios'
import { IhLogUrl, ihConfigUrl, ihFaceDetectUrl } from '@/api/config'
import { errorCollection } from '@/api/dmp/dmpCollection'
import store from '@/store/index'

/**
 * 根据用户ID分页查询音频记录
 */
export function listAudio(params) {
  const url = IhLogUrl + '/logs/page/audio'

  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('实时监控', '根据用户ID分页查询音频记录', res)
    }
    // 内外网ip转换
    if (!store.getters.isCloud && res.data && res.data.value && res.data.value.list) {
      let innerIp = store.getters.innerIp
      let outerIp = store.getters.outerIp
      let thisIp = location.hostname
      let replaceFrom = ''
      let replaceTo = ''
      if (thisIp.indexOf(innerIp) > -1) {
        replaceFrom = outerIp
        replaceTo = innerIp
      } else if (thisIp.indexOf(outerIp) > -1 || thisIp.indexOf('localhost') > -1) {
        replaceFrom = innerIp
        replaceTo = outerIp
      }
      if (replaceFrom && replaceTo) {
        res.data.value.list.forEach(item => {
          if (item.mediaUrl) {
            if (item.mediaUrl.indexOf(replaceTo) > -1) {
              return Promise.resolve(res.data)
            }
            item.mediaUrl = item.mediaUrl.replace(replaceFrom, replaceTo)
          }
        })
      }
    }
    return Promise.resolve(res.data)
  })
}

/**
 * 根据用户ID分页查询轨迹记录
 */
export function listGps(params) {
  const url = IhLogUrl + '/logs/page/gps'

  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('实时监控', '根据用户ID分页查询轨迹记录', res)
    }
    return Promise.resolve(res.data)
  })
}

/**
 * 根据用户ID分页查询全部轨迹记录
 */
export function listAllGps(params) {
  const url = IhLogUrl + '/logs/page/all/gps'

  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('实时监控', '根据用户ID分页查询轨迹记录', res)
    }
    return Promise.resolve(res.data)
  })
}
/**
 * 根据用户ID分页查询图片记录
 */
export function listPhoto(params) {
  const url = IhLogUrl + '/logs/page/photo'

  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('实时监控', '根据用户ID分页查询图片记录', res)
    }
    // 内外网ip转换
    if (!store.getters.isCloud && res.data && res.data.value && res.data.value.list) {
      let innerIp = store.getters.innerIp
      let outerIp = store.getters.outerIp
      let thisIp = location.hostname
      let replaceFrom = ''
      let replaceTo = ''
      if (thisIp.indexOf(innerIp) > -1) {
        replaceFrom = outerIp
        replaceTo = innerIp
      } else if (thisIp.indexOf(outerIp) > -1 || thisIp.indexOf('localhost') > -1) {
        replaceFrom = innerIp
        replaceTo = outerIp
      }
      if (replaceFrom && replaceTo) {
        res.data.value.list.forEach(item => {
          if (item.mediaUrl) {
            if (item.mediaUrl.indexOf(replaceTo) > -1) {
              return Promise.resolve(res.data)
            }
            item.mediaUrl = item.mediaUrl.replace(replaceFrom, replaceTo)
          }
          if (item.preMediaUrl) {
            item.preMediaUrl = item.preMediaUrl.replace(replaceFrom, replaceTo)
          }
        })
      }
    }
    return Promise.resolve(res.data)
  })
}

/**
 * 根据用户ID分页查询图片记录
 */
export function listAllPhoto(params) {
  const url = IhLogUrl + '/logs/page/all/photo'

  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('实时监控', '根据用户ID分页查询图片记录', res)
    }
    // 内外网ip转换
    if (!store.getters.isCloud && res.data && res.data.value && res.data.value.list) {
      let innerIp = store.getters.innerIp
      let outerIp = store.getters.outerIp
      let thisIp = location.hostname
      let replaceFrom = ''
      let replaceTo = ''
      if (thisIp.indexOf(innerIp) > -1) {
        replaceFrom = outerIp
        replaceTo = innerIp
      } else if (thisIp.indexOf(outerIp) > -1 || thisIp.indexOf('localhost') > -1) {
        replaceFrom = innerIp
        replaceTo = outerIp
      }
      if (replaceFrom && replaceTo) {
        res.data.value.list.forEach(item => {
          if (item.mediaUrl) {
            if (item.mediaUrl.indexOf(replaceTo) > -1) {
              return Promise.resolve(res.data)
            }
            item.mediaUrl = item.mediaUrl.replace(replaceFrom, replaceTo)
          }
          if (item.preMediaUrl) {
            item.preMediaUrl = item.preMediaUrl.replace(replaceFrom, replaceTo)
          }
        })
      }
    }
    return Promise.resolve(res.data)
  })
}
/**
 * 根据用户ID分页查询视频录制记录
 */
export function listRecording(params) {
  const url = ihConfigUrl + '/rtc/video/message'

  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('实时监控', '根据用户ID分页查询视频录制记录', res)
    }
    return Promise.resolve(res.data)
  })
}

//导出根据关键字分页查询头盔模块日志记录
export function getExportModules(params) {
  const url = IhLogUrl + '/modules/export'
  return axios({
    method: 'get',
    url: url,
    params: params,
    responseType: 'blob',
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('导出信息', '模块日志记录', res)
    }
    return Promise.resolve(res.data)
  })
}
//导出导出人员活跃、数据统计数据
export function getExportStatistics(params) {
  const url = IhLogUrl + '/active/statistics/export'
  return axios({
    method: 'get',
    url: url,
    params: params,
    responseType: 'blob',
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('导出信息', '人员活跃、数据统计数据', res)
    }
    return Promise.resolve(res.data)
  })
}
//导出围栏进出统计
export function getExportStatGeoFences(params) {
  const url = IhLogUrl + '/geoFences/statistics/export'
  return axios({
    method: 'get',
    url: url,
    params: params,
    responseType: 'blob',
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('导出信息', '围栏进出统计', res)
    }
    return Promise.resolve(res.data)
  })
}

//导出根据关键字分页查询电池电量日志
export function getExportBatterys(params) {
  const url = IhLogUrl + '/batterys/export'
  return axios({
    method: 'get',
    url: url,
    params: params,
    responseType: 'blob',
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('导出信息', '电池电量日志', res)
    }
    return Promise.resolve(res.data)
  })
}
//导出根据关键字分页查询媒体上传信息日志
export function getExportMediaUpload(params) {
  const url = IhLogUrl + '/mediaUploadInfo/export'
  return axios({
    method: 'get',
    url: url,
    params: params,
    responseType: 'blob',
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('导出信息', '媒体上传信息日志', res)
    }
    return Promise.resolve(res.data)
  })
}
//导出根据关键字分页查询数据流量日志记录
export function getExportMobileDatas(params) {
  const url = IhLogUrl + '/mobileDatas/export'
  return axios({
    method: 'get',
    url: url,
    params: params,
    responseType: 'blob',
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('导出信息', '数据流量日志记录', res)
    }
    return Promise.resolve(res.data)
  })
}
//导出设备数据
export function getExportDevice(params) {
  const url = IhLogUrl + '/status/device/export'
  return axios({
    method: 'get',
    url: url,
    params: params,
    responseType: 'blob',
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('导出信息', '导出设备数据', res)
    }
    return Promise.resolve(res.data)
  })
}
//导出根据关键字分页查询一键求助日志记录，分页查询
export function getExportEmergency(params) {
  const url = IhLogUrl + '/emergencyHelp/export'
  return axios({
    method: 'get',
    url: url,
    params: params,
    responseType: 'blob',
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('导出信息', '一键求助日志记录', res)
    }
    return Promise.resolve(res.data)
  })
}
//导出根据关键字分页查询后台操作日志记录
export function getExportOperations(params) {
  const url = IhLogUrl + '/operations/export'
  return axios({
    method: 'get',
    url: url,
    params: params,
    responseType: 'blob',
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('导出信息', '后台操作日志记录', res)
    }
    return Promise.resolve(res.data)
  })
}
//导出根据关键字分页查询电子围栏日志，分页查询
export function getExportGeoFences(params) {
  const url = IhLogUrl + '/geoFences/export'
  return axios({
    method: 'get',
    url: url,
    params: params,
    responseType: 'blob',
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('导出信息', '电子围栏日志', res)
    }
    return Promise.resolve(res.data)
  })
}
//导出分页查询模式切换记录
export function getExportSwitch(params) {
  const url = IhLogUrl + '/mode/switch/export'
  return axios({
    method: 'get',
    url: url,
    params: params,
    responseType: 'blob',
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('导出信息', '模式切换记录', res)
    }
    return Promise.resolve(res.data)
  })
}

//导出分页查询人脸识别流水记录
export function getExportFaceDetect(params) {
  const url = ihFaceDetectUrl + '/faceDetect/log/export'
  return axios({
    method: 'get',
    url: url,
    params: params,
    responseType: 'blob',
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('导出信息', '人脸识别记录', res)
    }
    return Promise.resolve(res.data)
  })
}
//导出分页查询声纹识别流水记录
export function getExportVoiceDetect(params) {
  const url = ihFaceDetectUrl + '/voiceDetect/log/export'
  return axios({
    method: 'get',
    url: url,
    params: params,
    responseType: 'blob',
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('导出信息', '声纹识别记录', res)
    }
    return Promise.resolve(res.data)
  })
}

// 根据关键字分页查询电量续航统计
export function batterysEndurance(params) {
  const url = IhLogUrl + '/batterys/endurance'

  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('电池电量记录', '根据关键字分页查询电量续航统计', res)
    }
    return Promise.resolve(res.data)
  })
}
// 统计耗电续航统计的日均使用时长和日均耗电量
export function batterysSstatistics(params) {
  const url = IhLogUrl + '/batterys/endurance/statistics'

  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('电池电量记录', '统计耗电续航统计的日均使用时长和日均耗电量', res)
    }
    return Promise.resolve(res.data)
  })
}